import script from "./CreateJournal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateJournal.vue?vue&type=script&setup=true&lang=js"

import "./CreateJournal.vue?vue&type=style&index=0&id=7fb5ef51&scoped=true&lang=css"
import "./CreateJournal.vue?vue&type=style&index=1&id=7fb5ef51&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb5ef51"]])

export default __exports__